import React from "react";
import {
  CustomTooltipContent,
  ReferralMessageDetails,
  TooltipBody,
  TooltipHeading,
} from "../../message/messageType/contentType/smartContent/SmartContent.style";
import { Tooltip } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import { useTranslation } from "hhn-commons";

type MemberNameWithStatusType = {
  isUserAlreadyInGroup?: boolean;
  hasReferral?: boolean;
  referralMessage?: string;
};

const UserNameWithStatus = ({
  isUserAlreadyInGroup,
  hasReferral,
  referralMessage,
}: MemberNameWithStatusType) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });

  return (
    <>
      {isUserAlreadyInGroup && tNs("alreadyAdded")}
      {hasReferral && (
        <>
          <ReferralMessageDetails>
            {tNs("smartContent.sentReferral")}
            <Tooltip
              title={
                <CustomTooltipContent>
                  <TooltipHeading data-testid="referral-message-heading">
                    {tNs("smartContent.referralMessage")}
                  </TooltipHeading>
                  <TooltipBody data-testid="referral-message-body">
                    {referralMessage ? referralMessage : "N/A"}
                  </TooltipBody>
                </CustomTooltipContent>
              }
              placement="top"
            >
              <ChatIcon
                color="primary"
                fontSize="small"
                data-testid="info-btn"
              />
            </Tooltip>
          </ReferralMessageDetails>
        </>
      )}
    </>
  );
};

export default UserNameWithStatus;
